<div mat-dialog-close class="d-flex justify-content-end ">
  <img src="./assets/img/close.svg" alt="Prefill data" />
</div>

<div class="d-flex justify-content-center mb-1">
  <img src="./assets/img/warning.svg" alt="Prefill data" />
</div>

<div mat-dialog-title class="d-flex justify-content-center">
  Switch to other option?
</div>

<div mat-dialog-content class="d-flex justify-content-center">
  Your data and any generated visualization will be cleared once you switch to other option.
</div>

<div mat-dialog-actions class="d-flex justify-content-space-around mb-1">
  <button class="btn btn-secondary" [mat-dialog-close]="false">Cancel</button>
  <button class="btn btn-primary" [mat-dialog-close]="true">Ok</button>
</div>